import React from "react";
import {
  CopyrightMessage,
  FallbackFooterBackground
} from "./FallbackFooter.styled";

const FallbackFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <FallbackFooterBackground>
      <CopyrightMessage>
        © {currentYear} EBSCO Industries, Inc. All rights reserved.
      </CopyrightMessage>
    </FallbackFooterBackground>
  );
};

export default FallbackFooter;
